//libs
import React,{Component} from "react";
import {connect} from "react-redux";
import ReactDropzone from 'react-dropzone';

//components
import Loading from "../../UI_Elements/Loading";
//other
import {post} from "../../../actions/fileImport";
import {postWithEmail} from "../../../actions/fileImportIncludeEmail";
import {notification} from "../../../helpers";


class ImportForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fileName:"Släpp filen eller klicka här (*.xls,*.xlsx)",
            files:[],
            isChecked: false
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    onDrop(fs){
        // POST to a test endpoint for demo purposes
        if (fs.length>1){
            notification("Allowed only one file!");
        }
        let x = null;
        var newFiles = [];
        for(x in fs){
            newFiles.push(fs[x]);
        }
        this.setState({
            files:newFiles
        });
    }

    validateForm(){
        if (this.state.files.length===1){
            return true;
        }
        return false;
    }

    handleFileUpload(e){
        if (this.state.files.length>0){
            if(!this.state.isChecked) {
                this.props.post(this.state.files[0]);
            } else {
                this.props.postWithEmail(this.state.files[0]);
            }
        }
        this.setState({files:[]});
        e.preventDefault();
    }

    handleCheckboxChange = (event) => {
        this.setState({isChecked: event.target.checked});
    }

    render() {

        if (this.props.submitting){
            return (
                <div className='box edit-last-on-rent-date'>
                    <div className='box-inner'>
                        <Loading show={true}/>
                    </div>
                </div>
            )
        }
        let buttonTitle="Import";
        const {fileName,files} = this.state;
        const {submitting} = this.props;

        return (
            <div className='box edit-last-on-rent-date importForm'>
                <div className='box-inner'>
                    <h2>{buttonTitle}</h2>
                    <form onSubmit={(event)=>this.handleFileUpload(event)}>
                        <div className={"dropZoneOuterBox"}>
                            {files.length===0 &&
                                <ReactDropzone
                                    className={"dropZone"}
                                    style={null}
                                    onDrop={this.onDrop.bind(this)}
                                    multiple={false}
                                    //accept={['application/vnd.ms-excel','application/xls','application/xlsx','.application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
                                >
                                    <span className={"dropZoneInnerBox"}>{fileName}</span>
                                </ReactDropzone>
                            }
                            <div style={{ 
                                    display: "flex", 
                                    flexDirection: "row", 
                                    gap: "3px", 
                                    lineHeight: "22px", 
                                    marginTop: "10px"
                                }}>
                                <input 
                                    type="checkbox" 
                                    checked={this.state.isChecked}
                                    id="checkbox"
                                    name="checkbox"
                                    onChange={this.handleCheckboxChange}
                                    style={{
                                        cursor: "pointer", 
                                        height: "16px",
                                        width: "16px",
                                    }}
                                />
                                <label htmlFor="checkbox">Inkludera mejl till GY</label>
                            </div>          
                            
                            {!submitting &&
                                <input
                                    type="submit"
                                    disabled={files.length!==1}
                                    className="submit creategroupsubmit form-submit"
                                    value={"Ladda upp data"}
                                />
                            }

                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForEditLastOnRentDate = (state) => {
        return {
        submitting: state.fileImport.submitting
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForEditLastOnRentDate = (dispatch) => {
    return {
        post: (file) => dispatch(post(file)),
        postWithEmail: (file) => dispatch(postWithEmail(file))
    };
};

/**
 * Create groups
 */
export default connect(mapStateToPropsForEditLastOnRentDate, mapDispatchToPropsForEditLastOnRentDate)(ImportForm);


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/ImportForm.js